import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const RECENT_ACTIVITY_ROUTE = {
  name: 'recentactivity/:studentId',
  route(classId: string, studentId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'recentactivity', studentId];
  }
};
